import { graphql } from "@opensea/graphql"
import { ItemPreviewTooltipContentFragment } from "./ItemPreviewTooltipContent.fragment"

export const ItemPreviewTooltipFragment = graphql(
  `
    fragment ItemPreviewTooltip on ItemIdentifier {
      ...ItemPreviewTooltipContent
    }
  `,
  [ItemPreviewTooltipContentFragment],
)
